export default {
  restore: 'Restore',
  'Are you sure to restore the selected records?':
    'Are you sure to restore the selected records?',
  'Restore the selected record to the original data table':
    'Restore the selected record to the original data table.',
  'Operation administrator': 'Operation administrator',
  'Recycling rule name': 'Recycling rule name',
  'Rule name': 'Rule name',
  controller: 'Controller',
  'data sheet': 'Data table',
  DeletedData: 'Deleted data',
  'Arbitrary fragment fuzzy query': 'Arbitrary fragment fuzzy query',
  'Click to expand': 'Click to expand',
  'Data table primary key': 'Data table primary key',
  'Operator IP': 'Operator IP',
  'Deleted data': 'Deleted data',
  'Delete time': 'Delete time'
}
